import { CardHeader, styled } from "@mui/material";

export const OverflowingCardHeader = styled(CardHeader)`& .MuiCardHeader-content { overflow: hidden; }`;